import { render } from "./ping.vue?vue&type=template&id=34580e7a&scoped=true"
import script from "./ping.vue?vue&type=script&lang=js"
export * from "./ping.vue?vue&type=script&lang=js"

import "./ping.vue?vue&type=style&index=0&id=34580e7a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34580e7a"]])

export default __exports__